export default __webpack_public_path__ + "static/media/070-raccoon.f10aca80.svg";